<template>
  <HeaderContent title="Staff Position" />
  <ActionContent
    ctaText="Add Staff Position"
    @action="showModal"
    :filterDate="false"
    :filterModal="false"
    @search-query="searchData"
  />
  <StaffPositionStatistics
    title="Staff Position Statistics"
    :data="statistics"
  />
  <StaffPositionForm
    :modal="modal"
    :staffPositionData="staffPosition"
    @update:modal="updateModal"
    @addOrUpdate="getAll"
  />
  <StaffPositionConfirm
    title="Confirmation"
    :uuid="staffPositionUuid"
    @confirmed="deleteData"
    v-model="modalConfirm"
  >
    <template #text>Are you sure to delete this data ?</template>
  </StaffPositionConfirm>
  <StaffPositionDataTable
    :data="staffPositions"
    :header="headers"
    :currentPage="currentPage"
    :custom-actions="customActions"
  />
  <ToastResponse
    v-model="modalResponse.toast"
    :text="modalResponse.text"
    :success="modalResponse.success"
  />
</template>

<script>
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import StaffPositionForm from "./StaffPositionForm.vue";
import StaffPositionDataTable from "@/components/DataTable.vue";
import StaffPositionStatistics from "@/components/StatisticData.vue";
import StaffPositionConfirm from "@/components/ModalDialog.vue";
import ToastResponse from "@/components/ToastResponse.vue";
import iconRank from "../../../public/icons/rank.svg";
import { ref, inject, onMounted } from "vue";

export default {
  components: {
    HeaderContent,
    ActionContent,
    StaffPositionForm,
    StaffPositionDataTable,
    StaffPositionStatistics,
    StaffPositionConfirm,
    ToastResponse,
  },
  setup() {
    const repositories = inject("repositories");
    const staffPositionRepository = repositories
      ? repositories.staffPosition
      : null;
    const modal = ref(false);
    const modalConfirm = ref(false);
    const staffPositionUuid = ref(null);
    const staffPosition = ref({});
    const staffPositions = ref([]);

    const headers = ref([
      {
        key: "no",
        label: "No",
        class: "text-left",
      },
      {
        key: "name",
        label: "Name",
        sortable: true,
        class: "text-left",
      },
      {
        key: "description",
        label: "Description",
        sortable: true,
        class: "text-left",
      },
      {
        key: "action",
        label: "Actions",
      },
    ]);

    const customActions = ref([
      {
        label: "Edit",
        variant: "success",
        icon: "fas fa-edit",
        action: (item) => {
          getById(item.uuid);
        },
      },
      {
        label: "Delete",
        variant: "danger",
        icon: "fas fa-trash",
        action: (item) => {
          showConfirmModal(item.uuid);
        },
      },
    ]);

    const statistics = ref([]);

    const getAll = async () => {
      await staffPositionRepository
        .getAll()
        .then((res) => {
          staffPositions.value = res.data.data;
          statistics.value = [
            {
              label: "Total",
              key: "Staff Position",
              value: res.data.data.length,
              color: "primary",
              icon: iconRank,
            },
          ];
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const getById = async (uuid) => {
      await staffPositionRepository
        .getById(uuid)
        .then((res) => {
          staffPosition.value = res.data.data;
          modal.value = true;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const updateModal = (newValue) => {
      modal.value = newValue;
      staffPosition.value = {};
    };

    const showModal = () => {
      modal.value = true;
    };

    const showConfirmModal = (uuid) => {
      modalConfirm.value = true;
      staffPositionUuid.value = uuid;
    };

    const modalResponse = ref({
      toast: false,
      text: "",
      success: false,
    });

    const deleteData = async () => {
      await staffPositionRepository
        .delete(staffPositionUuid.value)
        .then(() => {
          modalConfirm.value = false;
          getAll();
        })
        .catch((err) => {
          console.error(err);
          Object.assign(modalResponse.value, {
            success: false,
            text: err.response.data.message,
            toast: true,
          });
        });
    };

    const searchData = async (keyword) => {
      await staffPositionRepository
        .search(keyword)
        .then((res) => {
          staffPositions.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    onMounted(() => {
      getAll();
    });

    return {
      modal,
      modalConfirm,
      staffPositionUuid,
      staffPosition,
      staffPositions,
      headers,
      customActions,
      statistics,
      updateModal,
      showModal,
      showConfirmModal,
      deleteData,
      getAll,
      getById,
      searchData,
      modalResponse,
    };
  },
};
</script>
